import { AbstractFormArgument } from '../global'

class FormArgument extends AbstractFormArgument {
  constructor () {
    super()
    this.name = ''
    this.mobile = ''
    this.address = []
    this.province = ''
    this.city = ''
    this.area = ''
    this.street = ''
    this.postalCode = ''
  }
}

class AddFormArgument extends AbstractFormArgument {
  constructor () {
    super()
    this.goodId = ''
    this.amount = ''
    this.addressId = ''
  }
}

export {
  FormArgument,
  AddFormArgument
}



// WEBPACK FOOTER //
// ./src/models/client/shop-address.js